/** Small inline SVGs for track vertex popup rows (currentColor, 20×20). */

const SVG_ATTRS =
  'xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="14" height="14" aria-hidden="true"';

export function trackPopupClockIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z" clip-rule="evenodd"/></svg>`;
}

export function trackPopupBoltIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path d="M11.983 1.907a.75.75 0 00-1.292-.657l-8.5 9.5A.75.75 0 002.75 12h6.572l-1.305 6.093a.75.75 0 001.292.657l8.5-9.5A.75.75 0 0017.25 8h-6.572l1.305-6.093z"/></svg>`;
}

export function trackPopupCrosshairIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path d="M10 3.5a.75.75 0 01.75.75v1.064a4.752 4.752 0 013.936 3.936H15.75a.75.75 0 010 1.5h-1.064a4.752 4.752 0 01-3.936 3.936V15.75a.75.75 0 01-1.5 0v-1.064a4.752 4.752 0 01-3.936-3.936H4.25a.75.75 0 010-1.5h1.064A4.752 4.752 0 019.25 5.314V4.25A.75.75 0 0110 3.5zm0 3a3.25 3.25 0 100 6.5 3.25 3.25 0 000-6.5z"/></svg>`;
}

/** Map pin for address rows on live-position popups. */
export function trackPopupPinIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path fill-rule="evenodd" d="M9.69 18.933l.003.001C9.89 19.303 10.319 20 11 20s1.11-.697 1.307-1.066l.002-.001.006-.003.018-.01a168.087 168.087 0 002.48-1.525c.658-.46 1.48-1.1 2.303-1.913C18.482 13.35 20 11.132 20 8.5a8.5 8.5 0 10-17 0c0 2.632 1.518 4.85 2.891 6.182a26.766 26.766 0 002.303 1.913 168.087 168.087 0 002.48 1.525l.018.01.006.003zM11 11.5a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/></svg>`;
}

/** Simplified satellite / GNSS mark. */
export function trackPopupSatelliteIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path d="M6.28 2.22a.75.75 0 00-1.06 1.06l1.06 1.06a3.5 3.5 0 00-.22 4.72l1.06-1.06a2 2 0 01.22-2.6L6.28 2.22zm7.44 0l-1.06 1.06a2 2 0 01.22 2.6l1.06 1.06a3.5 3.5 0 00-.22-4.72l1.06-1.06a.75.75 0 00-1.06-1.06zM10 7a3 3 0 100 6 3 3 0 000-6zm-4.22 6.72a3.5 3.5 0 004.72.22l1.06-1.06a2 2 0 01-2.6-.22l-3.18 3.18a.75.75 0 001.06 1.06l1.06-1.06a3.5 3.5 0 01-4.72-.22l1.06-1.06a2 2 0 012.6.22l-1.06 1.06zm8.44 0l-1.06 1.06a2 2 0 01-2.6-.22l-1.06 1.06a3.5 3.5 0 004.72.22l1.06 1.06a.75.75 0 001.06-1.06l-3.18-3.18a2 2 0 012.6.22l1.06-1.06a3.5 3.5 0 00-4.72-.22z"/></svg>`;
}

export function trackPopupWifiIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path fill-rule="evenodd" d="M.458 4.958A15.92 15.92 0 0110 1.5c3.652 0 7.021 1.228 9.542 3.458a.75.75 0 01-.964 1.149A14.42 14.42 0 0010 3a14.42 14.42 0 00-8.578 2.607.75.75 0 11-.964-1.149zm2.892 2.892A11.943 11.943 0 0110 5.5c2.745 0 5.28.92 7.65 2.35a.75.75 0 11-.845 1.24A10.443 10.443 0 0010 7c-2.39 0-4.596.8-6.405 2.09a.75.75 0 11-.845-1.24zM10 10.5a7.96 7.96 0 014.906 1.688.75.75 0 11-.912 1.19A6.46 6.46 0 0010 12a6.46 6.46 0 00-3.994 1.378.75.75 0 11-.912-1.19A7.96 7.96 0 0110 10.5zm0 4a2 2 0 100 4 2 2 0 000-4z" clip-rule="evenodd"/></svg>`;
}

export function trackPopupCellIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path d="M3.5 3.75a.75.75 0 00-1.5 0v12.5a.75.75 0 001.5 0V3.75zm4.25.75a.75.75 0 00-1.5 0v11.75a.75.75 0 001.5 0V4.5zm3.5 2a.75.75 0 00-1.5 0v9.75a.75.75 0 001.5 0V6.5zm3.5 2.25a.75.75 0 00-1.5 0v7.5a.75.75 0 001.5 0v-7.5zm3.25 2.5a.75.75 0 00-1.5 0v5a.75.75 0 001.5 0v-5z"/></svg>`;
}

export function trackPopupBluetoothIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path fill-rule="evenodd" d="M7.22 2.22a.75.75 0 011.06 0l4.25 4.25a.75.75 0 010 1.06L9.81 10l2.72 2.72a.75.75 0 010 1.06l-4.25 4.25a.75.75 0 01-1.28-.53V11.56L4.28 14.5a.75.75 0 11-1.06-1.06L7.19 9.47 3.22 5.5a.75.75 0 011.06-1.06l2.94 2.94V2.75a.75.75 0 01.22-.53zM8.75 11.56v4.19l2.19-2.19-2.19-2zM8.75 8.44l2.19-2.19-2.19-2.19v4.38z" clip-rule="evenodd"/></svg>`;
}

export function trackPopupAnchorIconSvg(): string {
  return `<svg ${SVG_ATTRS}><path fill-rule="evenodd" d="M10 2a2.25 2.25 0 100 4.5A2.25 2.25 0 0010 2zM6.25 8.5a.75.75 0 000 1.5h2.5v5.19A4.751 4.751 0 015.56 12.5a.75.75 0 00-1.12 1A6.25 6.25 0 0010 17.75 6.25 6.25 0 0015.56 13.5a.75.75 0 10-1.12-1 4.751 4.751 0 01-3.19 2.69V10h2.5a.75.75 0 000-1.5h-7.5z" clip-rule="evenodd"/></svg>`;
}

export function trackPopupFixTypeIconSvg(code: number): string {
  switch (code) {
    case 1:
      return trackPopupSatelliteIconSvg();
    case 2:
      return trackPopupWifiIconSvg();
    case 3:
      return trackPopupCellIconSvg();
    case 4:
      return trackPopupBluetoothIconSvg();
    case 5:
      return trackPopupAnchorIconSvg();
    default:
      return trackPopupSatelliteIconSvg();
  }
}
